module.exports = __webpack_public_path__ + "static/img/13.9ff6838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/13.png
// module id = A34k
// module chunks = 7